import { render, staticRenderFns } from "./rightsCourse.vue?vue&type=template&id=6fdfbf8a&scoped=true"
import script from "./rightsCourse.vue?vue&type=script&lang=js"
export * from "./rightsCourse.vue?vue&type=script&lang=js"
import style0 from "./rightsCourse.vue?vue&type=style&index=0&id=6fdfbf8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdfbf8a",
  null
  
)

export default component.exports